import { red } from "@mui/material/colors";
import { extendTheme } from "@mui/material/styles";
import resolveConfig from "tailwindcss/resolveConfig";

import { tailwindConfigModule } from "./tailwind.config";

const tailwindConfig = resolveConfig(tailwindConfigModule);

const COMMON_THEMING_OPTIONS = {
  typography: {
    fontSize: 14,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none" as const,
        },
      },
    },
  },
};

// A custom theme for this app
export const appTheme = {
  light: extendTheme({
    ...COMMON_THEMING_OPTIONS,
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: tailwindConfig.theme.colors.primary.main,
          },
          secondary: {
            main: "#01BDAC",
          },
          info: {
            main: "#0F62FE",
          },
          error: {
            main: red.A400,
          },
          background: {
            default: tailwindConfig.theme.colors.base.light,
            paper: tailwindConfig.theme.colors.surface.light,
          },
          text: {
            secondary: tailwindConfig.theme.colors.textSecondary.light,
          },
        },
      },
    },
  }),
  dark: extendTheme({
    ...COMMON_THEMING_OPTIONS,
    colorSchemes: {
      dark: {
        palette: {
          primary: {
            main: tailwindConfig.theme.colors.primary.main,
          },
          secondary: {
            main: "#01BDAC",
          },
          info: {
            main: "#0F62FE",
          },
          error: {
            main: red.A400,
          },
          background: {
            default: tailwindConfig.theme.colors.base.dark,
            paper: tailwindConfig.theme.colors.surface.dark,
          },
          text: {
            secondary: tailwindConfig.theme.colors.textSecondary.dark,
          },
        },
      },
    },
  }),
};
